import { ViewSyllabusComponent } from './../../shared/view-syllabus/view-syllabus.component';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '@app-services/dashboard/dashboard.service';
import { ExamService } from '@app-services/test/exam.service';
import { TestlistService } from '@app-services/test/testlist.service';
import { UserService } from '@app-services/user/user.service';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxSpinnerService } from "ngx-spinner";
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import * as moment from 'moment';
import {MatDialog, MatDialogConfig, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ScheduleService } from '@app-services/schedule/schedule.service';
import { TestRegistrationConfirmDialogComponent } from '@app-shared/components/test-registration-confirm-dialog/test-registration-confirm-dialog.component';
import { CommunicationMessageService } from '@app-services/communication-message/communication-message.service';
import { TenantConstant } from '@app-constants/tenant.constant';
import { registerNowPreStep, getTotalScore, calculateForJEEADV, filterJEEAdvancedPapers } from '@app-modules/feature/dashboard/component/assessment-board/assessment-board.component';
import { availableForAttempt, canRegisterTimeChecking, displayFormatedDateTime, attemptTestNow, comingSoon, attemptTestNowSCTB, availableForAttempt_moment } from '@app-modules/feature/dashboard/component/info-box/info-box.component';
import { SubscribemodalComponent } from '@app-shared/components/subscribemodal/subscribemodal.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TestSeriesScheduleComponent } from '@app-shared/components/test-series-schedule/test-series-schedule.component';
import { allowedExamNamesCT, CMSTestType, CUETExamtypes, examgraceTimeConstant, PaidSubscribedTest, testTypeValues, timeBoundTypes, schedulePdfUrl } from '@app-constants/app.constants';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ILTSScheduleComponent } from '../../shared/iltsschedule/iltsschedule.component';
import { getDateFromTestSpan, gotoList, timeConvert, isCurrentTimeGreaterExamEndtime, timeDifferencetestTimeandserver, filterCMSData, getExamName, getCourseName, getMomentUTCtime } from '@app-helpers/functions';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { Subject, timer } from 'rxjs';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { ClassService } from 'src/app/core/services/class.service';
import { TaskTimer } from 'tasktimer';
import { CyotShareOptionsComponent } from '../cyot-share-options/cyot-share-options.component';
import { TestComingSoonDialogComponent } from '@app-shared/components/test-coming-soon-dialog/test-coming-soon-dialog.component';
import { AllmessageComponent } from '@app-shared/components/allmessage/allmessage.component';
import { id } from 'date-fns/locale';
import { environment } from 'src/environments/environment';
import { takeUntil } from 'rxjs/operators';
import { PdfViewerComponent } from '@app-shared/components/pdf-viewer/pdf-viewer.component';
import { checkILTSRevampapplicable, examEndtime } from '../test-results/test-results/test-results.component';
import { ReferralDialogComponent } from '@app-shared/components/referral-dialog/referral-dialog.component';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';

@Component({
  selector: 'app-new-test-list',
  templateUrl: './new-test-list.component.html',
  styleUrls: ['./new-test-list.component.css']
})
export class NewTestListComponent implements OnInit {
  attemptedFilter: any = null;
  report: any = {
    'totaltests': 0,
    'completedtests':0,
    'totaltimespent':0,
    'highestscore': 0,
    'outofscore': 0,
    'highestRank': 0,
    'highestPercentile':0,
    'outofrank': 0,
  };
  overallTests:any = [];
  studentExamResult = [];
  examtype = "";
  examtypeId = {
    "examtype" : null,
    "name" : "",
    "value" : ""
  };
  examName = "";
  testsByScheduleId: any = {};
  attemptedTestsByScheduleId: any = {};
  testInfo = "";
  scheduleIds: any = [];
  completedJEEAdvancedScduleId:any =[]
  schedulesInfo: any = {};
  unAttemptedTestList:any = [];
  attemptAnotherClicked: any = false;
  attemptNowCLicked: any = false;
  token: any;
  detail: any;
  infoBoxes = [];
  currentTestBoxInfo: any = null;
  timeInterval: any = null;
  currentPage = 1;
  itemsPerPage = 6;
  tenant : any = TenantConstant.tenant;
  enrolledExamsCount: number = 0;
  filterTestList: any=[];
  totalScores: any = {};
  detailedReportPaper: any = "Combined";
  isTimeBoundTestType: boolean = false;
  noOfPapers: any = 1;
  isCurrentTimeGreaterExamEndtime = isCurrentTimeGreaterExamEndtime;
  availableForAttempt = availableForAttempt;
  canRegisterTimeChecking = canRegisterTimeChecking;
  displayFormatedDateTime = displayFormatedDateTime;
  registerNowPreStep = registerNowPreStep;
  timeConvert = timeConvert;
  attemptTestNow = attemptTestNow;
  attemptTestNowSCTB = attemptTestNowSCTB;
  getTotalScore = getTotalScore;
  comingSoon = comingSoon;
  calculateForJEEADV = calculateForJEEADV;
  filterJEEAdvancedPapers = filterJEEAdvancedPapers;
  timeDifferencetestTimeandserver = timeDifferencetestTimeandserver;
  viewTestReport = viewTestReport;
  availableForAttempt_moment =availableForAttempt_moment;
  getMomentUTCtime = getMomentUTCtime;
  showMoreAttempltedIndex: number = 5;
  showMoreCompletedIndex: number = 5;
  ongoingTestForAllExam: any;
  panelOpenState = false;
  portal: any = TenantConstant.portal;
  showSyallbusButton: boolean;
  schedulesData: any;
  latestTimeboundTestInterval: any = null;
  latestTimeboundTests: any = {};
  timeBoundTestOngoing: boolean = false;
  checkLatestTimeboundTestsheading: boolean = false;
  saveAllRuleIds: any[];
  saveJeeAdvAllRuleIds: any[] = [];
  testSuffix: string = "'s".toLowerCase();
  params: any;
  newListUtility :any = {
    testTimerSubscription:{},
    unEnrolled_before_endTime:{}
  }
  isJeeAdvUnAttAvailable: any[] = [];
  completedJeeAdvTest = [];
  notAttemptedJeeAdvTest = [];
  JeeadvacedScheduleIds:any = []
  branch: any = TenantConstant.branch;
  filterCMSData = filterCMSData;
  userData: any;
  isSubscribed: boolean = true;
  showPypPdf: boolean = false;
  cardTestSeggeration :any ={}
  pypPdfList: any=[
    {'1':'Math-Basic-Board Question Paper & Sol-2022','pCount':'22'},
    {'2':'Math-Standard-Board Question Paper & Sol-2022','pCount':'15'},
    {'3':'Science-Board Question Paper & Sol-2022','pCount':'26'},
    {'4':'Math-Basic-Board Question Paper & Sol-2021','pCount':'43'},
    {'5':'Math-Standard-Board Question Paper & Sol-2021','pCount':'27'},
    {'6':'Science-Board Question Paper & Sol-2021','pCount':'59'},
    {'7':'Math-Basic-Board Question Paper & Sol-2020','pCount':'40'},
    {'8':'Math-Standard-Board Question Paper & Sol-2020','pCount':'26'},
    {'9':'Science-Board Question Paper & Sol-2020','pCount':'36'},
    {'10':'Math-Basic-Board Question Paper & Sol-2019','pCount':'39'},
    {'11':'Science-Board Question Paper & Sol-2019','pCount':'36'},
    {'12':'Math-Basic-Board Question Paper & Sol-2018','pCount':'44'},
    {'13':'Science-Board Question Paper & Sol-2018','pCount':'37'},
    ];
  pdfLimit= 10;  
  filteredPdfList = [];
  enablePypPdf:boolean = environment?.pypPdf;
  private destroy$ = new Subject<boolean>();
  infoBoxName: any;
  shortName: any;
  constructor(
    private dashboardService: DashboardService,
    private examService: ExamService,
    private testListService: TestlistService,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private storage: LocalStorageService,
    private spinner: NgxSpinnerService,
    private gaService: GAnalyticsService,
    public dialog: MatDialog,
    private scheduleService: ScheduleService,
    private communicationMessageService:CommunicationMessageService,
    public  modalservice :NgbModal,
    private _eventHandlingService: EventHandlingService,
    private activatedRoute: ActivatedRoute,
    public classService :ClassService,
    private _inviteService:InviteEarnService,
   ) {
    this.testListService.refreshTestData.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (res) {
       this.testsByScheduleId ={};
       this.JeeadvacedScheduleIds=[];
       this.scheduleIds=[]
        this.GetNonAttempted_attemptedPaper()
      }
    });
    }

  ngOnInit(): void {
    this.userData = JSON.parse(localStorage.getItem('user_details_from_server'));
    let params = {...(this.route.snapshot.queryParams || {})};
    this.shortName = localStorage.getItem("shortname");
    this.testListService.selectedReportPaper =''
    // this.route.queryParams.subscribe(params => {
    this.examtype = params['examtype']?params['examtype']:'';
    if(this.examtype == 'CYOT') {this.examtype = '67521'};
    this.examtypeId = testTypeValues?.find(v=>v.name?.toUpperCase() ==this.examtype?.toUpperCase() )
    if(this.examtype == 'SCOREAWAT' || this.examtype =='SCOREMOCKTEST'|| this.examtype == 'SCORE23MOCKTEST'){
      this.router.navigate(['dashboard/testlist/score'],{queryParams:{examname:params['examname'],examtype:'SCHOLARSHIPTEST'}})
       return;
    }
    this.examName = params['examname'];
    let examName = localStorage.getItem("targetExamName") as string;
    this.detail = this.userService.getMobileAndName();
      const userGrade = String(this.detail?.grade) || this.detail?.grade?.name?.replace(/[^0-9]/g,'');
      if(allowedExamNamesCT[userGrade].indexOf(examName) < 0 || examName != this.examName) {
        this.router.navigateByUrl('/dashboard/assessment');
        return;
      }
    // if(examName !=='SCORE' && examName !=='NEET' && examName !== "JEEMAIN" && examName !== "JEEADVANCED" || examName != this.examName) {
    //   this.router.navigateByUrl('/dashboard');
    // }
    if(this.enablePypPdf){
      this.getUserGrade(this.detail?.grade);
    }
    this.isTimeBoundTestType = timeBoundTypes.indexOf(this.examtype) > -1;
    this.token = localStorage.getItem('token');
    this.testListService.getExamInfoBoxes().subscribe((data: any) => {
      this.infoBoxes = data;
      const tempexamType  = this.examtype == '67521' ? 'CYOT': this.examtype;
      let currentTestBoxInfo = data.find((info: any) => {
        return info.examname == this.examName && info.examtype == tempexamType;
      });
      this.currentTestBoxInfo = currentTestBoxInfo;
      this.infoBoxName = this.currentTestBoxInfo?.infoboxName
      // this.doTestCalculation();
      this.GetNonAttempted_attemptedPaper()
    });
    this.webevent(params)
  }


  handleScheduleAction(scheduleid: any, actionName: any, $event?: any): boolean {
    $event?.stopPropagation();
    let tests: any = [];
    this.testsByScheduleId[scheduleid]?.forEach(element => {
      if(Number(element?.papernum) == 1) {
        tests[0] = element;
      } else {
        tests[1] = element;
      }
    });
    if(this.testsByScheduleId[scheduleid]?.length>2){
      tests = [...this.testsByScheduleId[scheduleid]]
    }
    let lastTestindex = tests?.length - 1;
    if(!tests[0]) return false;
    
    if(actionName == 'BOTHPUBLISHED') {
      return (this.testsByScheduleId[scheduleid]?.[0].noofpapers == this.testsByScheduleId[scheduleid].length) ;
    }
    else if(actionName == 'isCurrentTimeGreaterExamEndtime') {
      return this.isCurrentTimeGreaterExamEndtime(tests[lastTestindex], null);
    }
    else if(actionName == 'attemptTestNowSCTB') {
      if(tests[0]?.testtaken || this.isCurrentTimeGreaterExamEndtime(tests[0], null)) {
          //assumption: check for paper 2 end time being hgher than current time is already done in the above if(actionName == 'isCurrentTimeGreaterExamEndtime') block
        this.attemptTestNowSCTB(tests[1], this.examtype);  
      } else {
        this.attemptTestNowSCTB(tests[0], this.examtype);
      }
    }
    else if(actionName == 'availableForAttempt') {
      //only for timebound type
      if(tests[0]?.testtaken || this.isCurrentTimeGreaterExamEndtime(tests[0], null)) {
          return this.availableForAttempt(tests[lastTestindex]);  
      } else {
        return this.availableForAttempt(tests[0]);
      } 
    }
    else if(actionName == 'comingSoon') {
      if(tests[0]?.testtaken || this.isCurrentTimeGreaterExamEndtime(tests[0], null)) {
          this.comingSoon(tests[1]);  
      } else {
        this.comingSoon(tests[0]);
      } 
    }
    else if(actionName == 'canRegisterTimeChecking') {
      // if(!tests[1]?.testtaken) {
      if(lastTestindex >-1 && !tests[lastTestindex]?.testtaken) {
        return this.canRegisterTimeChecking(tests[lastTestindex]);  
      }
    }   
    else if(actionName == 'registerNowPreStep') {
      // if(tests[1]) {
      if(tests[lastTestindex]) {
        this.registerNowPreStep(tests, this.examtype);
      } 
    }
    else if(actionName == 'attemptTestNow') {
      let test;
      if(this.isTimeBoundTestType) {
        if(this.isCurrentTimeGreaterExamEndtime(tests[0], null)) {
          if(!tests[1]?.testtaken) {
            test = tests[1];
          }
        } else {
          if(!tests[0].testtaken) {
            test = tests[0];
          } 
        } 
      } else {
        if(!tests[0].testtaken) {
          test = tests[0];
        } else if(tests[1]) {
          test = tests[1];
        }  
      }
      if(test) {
        this.attemptTestNow(test, this.examtype);
      }
    } else if(actionName == 'viewTestReport') {
      //change it to ScheduleReport
      if(tests[0]?.testtaken && tests[1]?.testtaken) {
        let test = tests[1];
        this.viewTestReport(test, true);
      } else if(this.schedulesInfo[scheduleid]['testtaken']) {
        alert("Aggregate report can only be viewed after attempting both the papers");
      }
    }
    return false;
  }


  testFunc(event:any, test:any){
    attemptTestNow(test, this.examtype)
  }
  updateTimeboundTests(): boolean {
    let timeboundTestsExist;
    timeBoundTypes.forEach(e => {
      if(this.latestTimeboundTests[e]) {
        this.latestTimeboundTests[e] = {
          ...this.latestTimeboundTests[e],
          updated:!this.latestTimeboundTests[e].updated
        }
      }
      
      let serverTime = localStorage.getItem('serverTime')+'000';
      let serverTimeNow = Number(serverTime);
      let timeBoundTests = this.overallTests.filter((testData: any) => {
        if (testData.examtype == e) {
          return !isCurrentTimeGreaterExamEndtime(testData, serverTimeNow);
        } else {
          return false;
        }
      });
      
      let timeBoundTestSortByDate:any = [];
      if (timeBoundTests.length) {
        timeboundTestsExist = true;
        timeBoundTestSortByDate = timeBoundTests.slice(0).sort((a: any, b: any) => {
          //@ts-ignore
          return getDateFromTestSpan(a.span) - getDateFromTestSpan(b.span);
        });
        let prevId = this.latestTimeboundTests[e]?._id;  
        let enrolled = this.latestTimeboundTests[e]?.enrolled;  
        this.latestTimeboundTests[e] = timeBoundTestSortByDate[0];
        if(this.latestTimeboundTests[e]._id == prevId) {
          this.latestTimeboundTests[e] = {
            ...this.latestTimeboundTests[e],
            enrolled
          }
        }
      }
    });
    this.timeBoundTestOngoing = Object.keys(this.latestTimeboundTests).length > 0;

    return timeboundTestsExist;
  }

  sortTestAndStoreForTimeboundType(filterTestList:any) {
    if (this.timeInterval) {
       this.timeInterval.stop();
    }
    //store upcoming test
    var upcomingTestsInOrderAsc:any = [];
    if (filterTestList.length>0) {
      let upcomingTests = filterTestList.filter((testData:any) => {
        let testStartTimeInt = parseInt(moment(testData.span, "YYYY-MM-DD hh:mm A").add(+testData.duration, 'minutes').format("YYYYMMDDHHmm"));
        let serverTime = localStorage.getItem('serverTime');
        let current_time = parseInt(moment.unix(Number(serverTime)).format("YYYYMMDDHHmm"));
        return testStartTimeInt >= current_time;
         
      });
      
      upcomingTestsInOrderAsc = upcomingTests.slice(0).sort((a: any, b: any) => {
        let aSpan = moment(a.span, "YYYY-MM-DD hh:mm A").format("YYYYMMDDHHmmss");
        let bSpan = moment(b.span, "YYYY-MM-DD hh:mm A").format("YYYYMMDDHHmmss");
        return parseInt(aSpan) - parseInt(bSpan);
      });

    }
   
    //store past test
    var pastTestsInOrderDesc:any = [];
    if (filterTestList.length>0) {
      let pastTests = filterTestList.filter((testData:any) => {
        // let testStartTimeInt = parseInt(moment(new Date(testData.span)).add(+testData.duration, 'minutes').format("YYYYMMDDHHmm"));
        let testStartTimeInt = parseInt(moment(testData.span, "YYYY-MM-DD hh:mm A").add(+testData.duration, 'minutes').format("YYYYMMDDHHmm"));

        let serverTime = localStorage.getItem('serverTime');
        let current_time = parseInt(moment.unix(Number(serverTime)).format("YYYYMMDDHHmm"));
        return testStartTimeInt < current_time;
      });

      pastTestsInOrderDesc = pastTests.slice().sort((a: any, b: any) => {
        let aSpan = moment(a.span, "YYYY-MM-DD hh:mm A").format("YYYYMMDDHHmmss");
        let bSpan = moment(b.span, "YYYY-MM-DD hh:mm A").format("YYYYMMDDHHmmss");
        return parseInt(bSpan) - parseInt(aSpan);
      });
    }
    pastTestsInOrderDesc = pastTestsInOrderDesc.sort((a,b) => moment(new Date(b?.span)).valueOf() - moment(new Date(a?.span)).valueOf());
    this.filterTestList = [...upcomingTestsInOrderAsc,...pastTestsInOrderDesc];
  }
   sortFunction(a:any,b:any){  
     return a?.examsubmittedon?.valueOf() < b?.examsubmittedon?.valueOf()? 1 : -1;
  };

  filterAttempted(examName?): void {
    this.attemptedFilter = 'attempted';
   this.filterTestList = this.cardTestSeggeration?.completedTests?.filter((dr: any) => dr.isExamSubmittedByUser  ||(moment(new Date(dr.span)).add(dr.duration,"minutes").unix() < moment().unix())).map((test)=>{
      test.isCurrentTimeGreaterExamEndtime = this.isCurrentTimeGreaterExamEndtime(test, null);
      test.canRegisterTimeChecking = this.canRegisterTimeChecking(test)
      return test;
    })
    if (this.isTimeBoundTestType) {
      this.sortTestAndStoreForTimeboundType(this.filterTestList);
    }else{
      if(examName == 'JEEADVANCED'){  
        
      }else
        this.filterTestList= this.filterTestList.filter(v=>v.isExamSubmittedByUser).sort(this.sortFunction)
    }
    // this.testListService.getCurrentServerTime();
    localStorage.setItem('serverTime', this.getMomentUTCtime())
  }

  filterUnattempted(): void {
    this.attemptedFilter = 'unattempted';
    this.filterTestList = this.cardTestSeggeration?.upcomingTests.filter((dr: any) =>  (moment(new Date(dr.span)).add(dr.duration,"minutes").unix() > moment().unix()|| !dr.isExamTimeExpired)).map((test)=>{
      test.isCurrentTimeGreaterExamEndtime = this.isCurrentTimeGreaterExamEndtime(test, null);
      test.availableForAttempt =this.availableForAttempt_moment(test) //this.availableForAttempt(test);
      test.canRegisterTimeChecking = this.canRegisterTimeChecking(test)
      test.timedifference_ms = this.timeDifferencetestTimeandserver(test)
      return test;
    })
    if (this.isTimeBoundTestType) {
      this.sortTestAndStoreForTimeboundType(this.filterTestList);
      this.filterTestList =this.filterTestList.filter(v=>!v.isCurrentTimeGreaterExamEndtime)
    }
    this.unEnrolled_Unscription();
    this.filterTestList?.forEach((v)=>{
      if(v.timedifference_ms){
        this.exams_graceLimit_passed(v)
      }
    })
    this.filterTestList?.filter((v)=>(((!v?.availableForAttempt && v?.enrolled)|| (v?.availableForAttempt && !v?.enrolled && v?.canRegisterTimeChecking))))?.forEach((v)=>{
      if(v?.timedifference_ms < 7200000){
        this.changeStatusOfButton(v)
      }
    })
    if (this.examName == 'JEEADVANCED') {
      this.cardTestSeggeration?.upcomingTests?.filter((v) => !v?.availableForAttempt && v?.enrolled)?.forEach((v) => {
        if(v?.timedifference_ms < 7200000){
          this.changeStatusOfButton(v)
        }
      })
    }
    this.saveAllRuleIds = [];
    this.filterTestList.forEach(elerules => {
      this.saveAllRuleIds.push(elerules?._id);
    });
    if(this.examtype == '67521'){//stands for CYOT 
      this.filterTestList = this.filterTestList.reverse()
    }
      this.notAttemptedJeeAdvTest = [];
      this.scheduleIds.forEach((scheduleid) => {
        if (this.isTimeBoundTestType && this.handleScheduleAction(scheduleid, 'BOTHPUBLISHED')) { 
          if (this.handleScheduleAction(scheduleid, 'isCurrentTimeGreaterExamEndtime')) {
          } else {
            let totalTest = this.testsByScheduleId[scheduleid]?.filter(totaltest => {
              if(totaltest.hasOwnProperty('testtaken')){
                return  !totaltest.testtaken
              }else {
                return (!totaltest.isExamSubmittedByUser && !totaltest.isExamTimeExpired)
              }
              }); 
            if (totalTest?.length > 0) {
              this.notAttemptedJeeAdvTest.push(scheduleid);
            }
          }
        } else if (!this.isTimeBoundTestType) {
          let totalTest = this.testsByScheduleId[scheduleid]?.filter(totaltest =>  {
            if(totaltest.hasOwnProperty('testtaken')){
              return  !totaltest.testtaken
            }else {
              return (!totaltest.isExamSubmittedByUser )
            }
            });
          if (totalTest?.length > 0) {
            this.notAttemptedJeeAdvTest.push(scheduleid);
          }
        }
      })
  }
/* change the nroll option to Register based on settimeout for particular test */
  changeStatusOfButton(test){      
    if(this.newListUtility.testTimerSubscription[test._id]){
      this.newListUtility.testTimerSubscription[test._id].unsubscribe();
    }
    this.newListUtility.testTimerSubscription[test._id] = timer(test?.timedifference_ms).subscribe(()=>{
      let index =  this.filterTestList?.findIndex(v=>v._id == test?._id)
      this.filterTestList[index].availableForAttempt = true;
      let indexongoing = this.ongoingTestForAllExam?.findIndex(v=>v._id ==  test?._id ) 
      if (this.examtype == 'SCHOLARSHIPTEST' && indexongoing != -1){
        this.ongoingTestForAllExam[indexongoing].availableForAttempt = true; 
      }else if(this.examName == 'JEEADVANCED'){
        let jeeadvindex =  this.testsByScheduleId[test.subruleid]?.findIndex(v=>v._id == test?._id);
        if(jeeadvindex!= -1 && this.testsByScheduleId[test.subruleid][jeeadvindex].enrolled){
          localStorage.setItem('serverTime', this.getMomentUTCtime())
          // this.testListService.getServerTime().then((resp)=>{
            this.testsByScheduleId ={}
            this.JeeadvacedScheduleIds=[];
            this.scheduleIds=[]
            this.testListService.refreshTestData.next(true)
          // })
        }
      }
    })
  } 
  clearFilter(): void {
    this.attemptedFilter = null;
    this.filterTestList = this.overallTests;
    if (timeBoundTypes.indexOf(this.examtype) > -1) {
      this.sortTestAndStoreForTimeboundType(this.filterTestList);
    }
  }
  exams_graceLimit_passed(test) {
    let time_before_examend = moment(test?.span,'YYYY-MM-DD hh:mm A').add(+test?.duration - examgraceTimeConstant, 'minutes')
    let refreshingTime =time_before_examend.diff( moment(),'milliseconds')
    if ( (refreshingTime  > 0 && refreshingTime < 14400001) || refreshingTime == 0 ) {
      this.newListUtility.unEnrolled_before_endTime[test._id] = timer(refreshingTime).subscribe(() => {
    if (this.attemptedFilter == 'unattempted') {
          let params = {
            type: 'recommended',
            page: 1,
            limit: 1,
            customFilter: ''
          };
          // this.classService.getClasses(params).subscribe((res: any) => {
            // if (res && res.statusCode == 200) {
          const servertime  = this.getMomentUTCtime()
              localStorage.setItem('serverTime', servertime);
              localStorage.setItem('examStartTime', servertime);
              localStorage.setItem('examcountdown', '');
              this.filterUnattempted()
            // }
          // });
        }
      })
    }
  }
  unEnrolled_Unscription() {
    let unEnrolled_before_endTime = this.newListUtility.unEnrolled_before_endTime && Object.keys(this.newListUtility.unEnrolled_before_endTime) ? Object.keys(this.newListUtility.unEnrolled_before_endTime) : []
    unEnrolled_before_endTime.forEach((v: any) => {
      this.newListUtility.unEnrolled_before_endTime[v].unsubscribe()
    })
  }

  displayFormatedDateTimeGridView(test:any) {
    let string =test.span;
    let examstart = moment(string, "YYYY-MM-DD hh:mm A").format("YYYY-MM-DD HH:mm");
    let examendDateTime = moment(examstart,'YYYY-MM-DD HH:mm').add(parseInt(test.duration), 'minutes').format('YYYY-MM-DD HH:mm');
    return moment(examstart, 'YYYY-MM-DD HH:mm').format('Do MMMM') +' : ' + moment(examstart, 'YYYY-MM-DD HH:mm').format('h:mm A') + '-' + moment(examendDateTime, 'YYYY-MM-DD HH:mm').format('h:mm A');
  }

  registerAll() {
    let notEnrolledTest = this.filterTestList.filter((test: any) => {
      return !test.enrolled
    });
    var upcomingNotEnrolledTest = [];
    if (notEnrolledTest.length) {
      upcomingNotEnrolledTest = notEnrolledTest.filter((notEnrolledTest:any) => {
        let examstart = moment(notEnrolledTest.span, "YYYY-MM-DD hh:mm A").format("YYYY-MM-DD HH:mm");
        let serverTime = localStorage.getItem('serverTime');
        let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm");
        let timeBefore1Min = moment(examstart, 'YYYY-MM-DD HH:mm').add(-1, 'minutes').format('YYYY-MM-DD HH:mm');
        
        let examendDateTimeMinus10Min = moment(examstart,'YYYY-MM-DD HH:mm').add(parseInt(notEnrolledTest.duration)-10, 'minutes').format('YYYY-MM-DD HH:mm');
        return moment(examendDateTimeMinus10Min).isAfter(current_time);
      })
    }
    
    if(this.examtype == "ILTS" || this.examtype == "TIMEBOUND" || this.examtype == "New NEET Timebound") { 
      const testType = this.tenant=='srichaitanya' ? "SCTS": "ILTS";
      this.gaService.sendEvent(
        `${testType}_register_all`, 
        `${testType}_dashboard`, 
        `${testType}_register_all`,  
        `${upcomingNotEnrolledTest.length}`,  
      );
    }

    if (upcomingNotEnrolledTest.length) {
      
      this.spinner.show();
      let rules: any = [];
      let testNameArray:any = [];
      let startTimeArray:any = [];
      let endTimeArray:any = [];
      let ruleIdArray:any = [];
      upcomingNotEnrolledTest.forEach((notEnrolledTest: any) => {
        rules.push({
          "ruleid": notEnrolledTest._id,
          "span": notEnrolledTest.span,
        });
        ruleIdArray.push(notEnrolledTest._id);
        let examstart = moment(notEnrolledTest.span, "YYYY-MM-DD hh:mm A").format("DD/MM/YYYY hh:mm A");
        let examendDateTime = moment(examstart,'DD/MM/YYYY hh:mm A').add(parseInt(notEnrolledTest.duration), 'minutes').format('DD/MM/YYYY hh:mm A');
        startTimeArray.push(examstart);
        endTimeArray.push(examendDateTime);
        testNameArray.push(notEnrolledTest.rulename)
      });
      let body = {
        "rules": rules,
        "studentid":localStorage.getItem('studentid'),
        phone: this.userService.getMobileAndName()?.phone,
      admissionNumber: this.tenant=='srichaitanya' ? localStorage.getItem('studentid'): '',
        "isActive":"true",
        "subscription": {
          "module": this.testListService?.getUSerExamlist?.packageKey,
          "id": this.testListService?.getUSerExamlist?.packageId
        }
      }
      this.scheduleService.registerExamSchedule(body).subscribe((data:any) => {
        this.filterTestList.forEach((eachTest: any) => {
            eachTest.enrolled=true
        });
          
        this.spinner.hide();

        let dialogRef = this.dialog.open(TestRegistrationConfirmDialogComponent, {
          height: '240px',
          width: '500px',
          data: {
            message1: 'Great!',
            message2: data.message,
          }
        
        });

      let phoneAndName = this.userService.getMobileAndName();

      if (phoneAndName && phoneAndName.phone) {
        let body:any={
          "applicationLink": window.location.origin+'/',
          "liveDCLink": window.location.origin+'/',
          "name": phoneAndName.firstName+" "+phoneAndName.lastName,
          "phonenumber":phoneAndName.phone,
          "resultlink": window.location.origin+'/',
          "span": startTimeArray.join(),
          "testEndTime": endTimeArray.join(),
          "testName": testNameArray.join()
        }
        this.communicationMessageService.multiRegistrationMessage(body).subscribe(()=>{})
      }

      }, err => {
        this.spinner.hide();
        
      });


    } else {
      alert("All tests already enrolled");
    }
  }
  
  onPageChange(page: number) {
      this.spinner.show();
      this.currentPage = page;
      const timer = new TaskTimer(1000);
      timer.add({id: 'task-1',totalRuns: 1, callback(task) {
        this.spinner.hide(); 
      }}).start();
    }
  openTestSeriesSchedule() {

    const config: MatDialogConfig = {
      width: '900px',
      panelClass:'mat-full',
      data: { examName: localStorage.getItem("targetExamName") }
    };
    const dialogRef = this.dialog.open(TestSeriesScheduleComponent, config);
  }
  ngOnDestroy() {
    if (this.timeInterval) {
      this.timeInterval.stop();
    }
    if (this.latestTimeboundTestInterval) {
      this.latestTimeboundTestInterval.stop();
      this.latestTimeboundTestInterval = null;
    }
    if(this.newListUtility.testTimerSubscription && Object(this.newListUtility.testTimerSubscription).length){
      Object(this.newListUtility.testTimerSubscription).forEach((v)=>{
        this.newListUtility.testTimerSubscription[v].unsubscribe();
      })
    }
    this.unEnrolled_Unscription()
    this.destroy$.next(false)
  }
  tabClick(tab: MatTabChangeEvent) {
    if (tab.index === 1) {
      this.showMoreAttempltedIndex = 5;
      this.filterAttempted(this.examName);
      if (this.examName == 'JEEADVANCED' && this.noOfPapers > 1) {
        // this.completedJeeAdvTest = [];
        this.scheduleIds.forEach((scheduleid) => {
          if (this.isTimeBoundTestType) { 
            if (this.handleScheduleAction(scheduleid, 'isCurrentTimeGreaterExamEndtime')) {
              this.completedJeeAdvTest.push(scheduleid);
            } else {
              let totalTest = this.testsByScheduleId[scheduleid]?.filter(totaltest => totaltest.testtaken);
              if (totalTest?.length > 0) {
                this.completedJeeAdvTest.push(scheduleid);
              }
            }
          } 
        })
      }
    } else {
      this.showMoreCompletedIndex = 5;
      this.filterUnattempted();
    }
  }

  showMore(val: string) {
    if (val === 'notattempt') {
      this.showMoreAttempltedIndex = this.examName == 'JEEADVANCED' ? this.notAttemptedJeeAdvTest?.length : this.filterTestList.length;
    } else {
      this.showMoreCompletedIndex = this.examName == 'JEEADVANCED' && this.noOfPapers > 1 ? this.completedJeeAdvTest?.length : this.filterTestList.length;
    }
  }
  
  viewSyllabus(id) {
    const config: MatDialogConfig = {
      panelClass: ['UNFAPP-mweb-modal', 'UNFAPP-view-syllabus-modal'],
      data: {
        examId: id
      },
      width: '360px',
      scrollStrategy: new NoopScrollStrategy()
    };
    const dialogRef = this.dialog.open(ViewSyllabusComponent, config);
    dialogRef.afterClosed().subscribe((value) => {
    })
  }

  gotoDialog() {
    var currGrade = this.detail?.grade
    let currExamName = this.examName
    var shortName = this.shortName.split(" ").join("+")
    if (currExamName === "CBSE") {
      currExamName = currExamName + `Grade${currGrade}`
    } else if (currExamName === "JEEADVANCED") {
      currExamName = 'JEEAdvanced'
    } else if (currExamName === "JEEMAIN") {
      currExamName = 'JEEMain'
    }
    const link  = schedulePdfUrl + `${currExamName}-Grade${currGrade}-${shortName}.pdf`
    const config: MatDialogConfig = {
      data: link,
      disableClose: false,
      scrollStrategy: new NoopScrollStrategy(),
      width: 'auto',
      panelClass: ['UNFAPP-pdfviewer-modal']
    };
    const dialogRef = this.dialog.open(PdfViewerComponent, config);
    dialogRef.afterOpened().subscribe(()=>{
      document.body.classList.add('modal-open');
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      document.body.classList.remove('modal-open');
    })
    // else {
    //   const config: MatDialogConfig = {
    //     panelClass: ['UNFAPP-ilts-schdulewidthpopup', 'UNFAPP-mweb-modal'],
    //     width:'980px',
    //     data: {
    //       coursetype: this.examName,
    //       examtype: this.examtype,
    //       grade: this.detail?.grade,
    //       data: this.schedulesData,
    //       rulesArray: this.examName == "JEEADVANCED" ? this.saveJeeAdvAllRuleIds : this.saveAllRuleIds
    //     },
    //   };
    //   const dialogRef = this.dialog.open(ILTSScheduleComponent, config);
    //   dialogRef.afterClosed().subscribe((value) => {
    //   })
    // }
  }

  registerNow(test:any) {
    let tests: any = [];
    if(this.examName == "JEEADVANCED") {
      tests = this.filterTestList.testLists.filter(t => test.scheduleid  == t.scheduleid);
      if(tests.length < (Number(test?.noofpapers) || 99999)) return;
    } else {
      tests = [test];
    }
    registerNowPreStep.call(this, tests, this.examtype);
  }

  viewQuestionPaper(test) {
    let examInfo = test;
    if (timeBoundTypes.indexOf(test?.examtype) != -1) {
      var examEndTime = moment(test?.span, "YYYY-MM-DD hh:mm A").add(+test?.duration, 'minutes')
      let serverTime = localStorage.getItem('serverTime');
      let current_time = moment.unix(Number(serverTime))
      if (!moment(current_time).isAfter(examEndTime)) {
        let dialogRef = this.dialog.open(TestComingSoonDialogComponent, {
          height: '280px',
          width: '500px',
          data: {
            message1: 'Coming Soon!',
            message2: 'The test is yet to get over. The solutions and question wise analysis will only be visible after ' + examEndTime.format("YYYY-MM-DD hh:mm A")
          }
        });
        return;
      }
    }
    let subjectsdata = [];
    const postdata = {
      scheduleid: test.scheduleid,
      ruleid: test._id,
      clearcache: true,
      studentid: localStorage.getItem('studentid'),
      attempt: test?.attempt||'1'
    }
    this.spinner.show();
    this.testListService.getExamQuestion(postdata).subscribe((allTestsbyStudent: any) => {
      let subData = allTestsbyStudent?.questions.subjects;
      if (subData) {
        subData.forEach((sub) => {
          subjectsdata.push({subjectname: sub.subjectname, subjectquestions: sub.questions?.length});
        })
      }
      
      examInfo.subjectsdata = subjectsdata;
      this.examService.setPresentExamInfo(test);
      this.router.navigateByUrl('/dashboard/view-questions-paper');
      // this.spinner.hide();
      // const timer = new TaskTimer(100);
      // timer.add({id: 'task-2',totalRuns: 1, callback(task) {
      //   window.location.reload();
      // }}).start();
    });
  }
  
  attemtExamNow(testInfo: any, examtype: any) {
    if (examtype == "ILTS" || examtype == "TIMEBOUND" || examtype == "New NEET Timebound" || examtype == "New NEET Mock Test" || examtype == "MOCKTEST") {// || examtype == "SCHOLARSHIPTEST"){
      //grandTests are free
      this.testListService.isUserSubscribed(examtype, [testInfo]).then((resp:any)=>{
        if (resp) {
          if (examtype == "SCHOLARSHIPTEST") {
            this.router.navigate(['/subscription', { 'from': 'assementilite', ...testInfo}])
          } else {
            var componentInstance = this.modalservice.open(SubscribemodalComponent, {
              centered: true, size: 'sm', windowClass: 'subscription-modal-custom'
            })
          }
          return;
        }        
        this.attemptTestNow(testInfo, examtype);
      });
    } else {
      this.attemptTestNow(testInfo, examtype);
    }
    this.testInfo = testInfo;
  }
  
  totalNumberOfJeeAdv(scheduleid) {
    if (this.isTimeBoundTestType && this.handleScheduleAction(scheduleid, 'BOTHPUBLISHED')) { 
      if (this.handleScheduleAction(scheduleid, 'isCurrentTimeGreaterExamEndtime')) {
        return false;
      } else {
        let totalTest = this.testsByScheduleId[scheduleid].filter(totaltest => !totaltest.testtaken);
        if (totalTest?.length > 0) {
          return true;
        }
      }
    } else if (!this.isTimeBoundTestType) {
      let totalTest = this.testsByScheduleId[scheduleid].filter(totaltest => !totaltest.testtaken);
      return totalTest?.length;
    }
  }
  
  totalNumberOfUnCompletedJeeAdv(scheduleid) {
      let totalTest = this.testsByScheduleId[scheduleid].filter(totaltest => !totaltest.testtaken);
      return totalTest.length;
    }
    
    totalNumberOfCompletedJeeAdv(scheduleid) {
      if (this.isTimeBoundTestType && this.handleScheduleAction(scheduleid, 'isCurrentTimeGreaterExamEndtime')) {
        let totalTest = this.testsByScheduleId[scheduleid].filter(totaltest => !totaltest.testtaken);
        return totalTest.length;
      } else {
        let totalTest = this.testsByScheduleId[scheduleid].filter(totaltest => totaltest.testtaken);
        return totalTest.length;
      }
    }
    
    checkCompletedTest(scheduleid) {
      if (this.isTimeBoundTestType) { 
        
        if (this.handleScheduleAction(scheduleid, 'isCurrentTimeGreaterExamEndtime')) {
            return true;
          } else {
            let totalTest = this.testsByScheduleId[scheduleid]?.filter(totaltest => totaltest.testtaken);
            if (totalTest.length > 0) {
              return true;
            }
          }
        } else if (!this.isTimeBoundTestType) {
          let totalTest = this.testsByScheduleId[scheduleid]?.filter(totaltest => totaltest.testtaken)||[];
          if (totalTest.length > 0) {
            return true;
          } 
        }
      }
      
  goBack() {
     let type = localStorage.getItem('SelectedTab') || 'dashboard';
     this.router.navigate([`/dashboard/${type}`])
   }

   ShareDialog(test:any, scheduleId?, index?) {
    let ruleId;
    if(scheduleId){
     this.filterTestList.forEach(element => {
      if(element.scheduleid == scheduleId) {
        ruleId = element._id;
      }
     });
    }else {
      ruleId = test._id;
    }
    const config: MatDialogConfig = {
    panelClass: ['CYOT-shreopt'],
    width:'250', 
    data: { studentId: localStorage.getItem('studentid'),
           ruleId: ruleId
    },
    };
    const dialogRef = this.dialog.open(CyotShareOptionsComponent, config);
   }

   checkIfUserSubscribed() {
    let testInfo = (this.examName == 'JEEADVANCED') ? this.JeeadvacedScheduleIds : this.filterTestList;
    if(testInfo.length == 0) { return };
    if (PaidSubscribedTest.findIndex( v=> v==this.examtype?.toUpperCase()) !=-1) {// || examtype == "SCHOLARSHIPTEST"){
      //  || this.examtype == "ILTS" || this.examtype == "TIMEBOUND" || this.examtype == "New NEET Timebound" || this.examtype == "New NEET Mock Test" || this.examtype == "MOCKTEST"
      this.testListService.isUserSubscribed(this.examtype, testInfo[0], 'attempt').then((resp: any) => { 
      if(!resp) this.isSubscribed =  true; else  this.isSubscribed = false;
      })
    }
  }
   
  /* G10 pyp detail section */
   getUserGrade(ev){
    if(ev == 10 && this.examtype== 'PREVIOUSYEAR'){ 
    this.showPypPdf = true;
    console.log(this.pypPdfList[0][1]);
    // this.testListService.getPdfFromBucket().subscribe((data)=>{
    //   console.log(data);
    // });
    }
  }
  seePypPdf(fName,index,pCount){
    // console.log(fName);
    console.log(pCount);
    this.router.navigate(['/dashboard/pyp-viewer'], { 
      state: { fName: fName, index:index,pCount:pCount } 
    });
  }
  showMorePdf(){
    this.pdfLimit += this.pdfLimit
    // this.filteredPdfList
  }
  GetNonAttempted_attemptedPaper(){    
    this.spinner.show()
    let body ={
      "studentId":  localStorage.getItem('studentid'),
      "testType": this.examtypeId?.value
    }
    this.testListService.getNotCompletedTest(body).pipe(takeUntil(this.destroy$)).subscribe((resp)=>{
    this.testListService.getUSerExamlist = resp; 
    this.isSubscribed = resp?.subscribeStatus;
      if(resp?.completedTests?.length){
        resp?.completedTests?.forEach(v=>{
          v.isExamSubmittedByUser = true;
          v.totaltimespend =timeConvert(v?.timespent||0)
          v.testtaken = (v.status == 'COMPLETED' &&  v?.examsubmittedon) ? true : false;// v?.examsubmittedon can be removed after asseement deplayment
          v._id = v.id;
           v?.examsubmittedon
          v.examtype = getExamName(v?.test_type);
          v.displayFormatedDateTime = this.displayFormatedDateTime(v);
        })
      }
      if(resp?.upcomingTests?.length){
        resp?.upcomingTests?.forEach(v=>{
          v._id=v?.id;
          v.enrolled = v?.status?.toUpperCase() =='REGISTERED'? true: false;
          v.displayFormatedDateTime = this.displayFormatedDateTime(v);
        })
      }
      if(resp?.ongoingTests?.length){
        resp?.ongoingTests?.forEach((testrow)=>{
          testrow.resume = true;
          testrow.isExamInProgress= true;
          testrow.isExamSubmittedByUser=false;
          testrow.isExamTimeExpired=false;
          testrow._id=testrow.id;
          testrow.enrolled = testrow?.status?.toUpperCase() =='INPROGRESS'? true: false;
          testrow.displayFormatedDateTime = this.displayFormatedDateTime(testrow);
        })
        this.ongoingTestForAllExam = resp?.ongoingTests?.filter((ongoing) => ongoing.isExamInProgress &&!ongoing?.isExamSubmittedByUser && !ongoing?.isExamTimeExpired);
        resp?.upcomingTests.unshift(...resp?.ongoingTests)
      }
     this.cardTestSeggeration = {...resp}
     this.report = {
      'totaltests': resp?.report?.totalTestsCount||0,
      'completedtests':resp?.report?.testsTaken||0,
      'totaltimespent': timeConvert(resp?.report?.totalTimeSpent||0)||0,
      'highestscore': resp?.report?.highestScore||0,
      'outofscore': resp?.report?.highestScore||0,
      'highestRank': resp?.report?.rank||0,
      'highestPercentile':resp?.report?.percentile||0,
      'outofrank': resp?.report?.rank||0,
    };    

    if(this.report?.highestRank == 1){
      this._inviteService?.userReferralRemider(this.userData?.userId,{})?.subscribe((res:any)=>{
        if(res?.showReminder){
          this._inviteService?.invokeReferralDialog(this.dialog,this.userData?.userId)
        }
      })
    }

    if(this.examName == "JEEADVANCED") {  
      this.JeeAdvancedCardFormatating()
    }else {      
      this.filterUnattempted();
      }
      this.spinner.hide()
    },()=>{
      this.spinner.hide()
    })
  }
  JeeAdvancedCardFormatating(){
    this.spinner.show();
    this.noOfPapers =2;
    let filterCMSData = this.filterCMSData();
    let examName = localStorage.getItem("targetExamName") as string;
  
    this.cardTestSeggeration?.upcomingTests?.sort((a, b) =>  b?.papernum - a?.papernum )?.forEach((testData, i,self) => {
      if (!this.testsByScheduleId[testData?.subruleid]) {
        this.testsByScheduleId[testData?.subruleid] = [];
      }
      testData.rank = 0;
      testData.percentile = 0;
      testData.enrolled = testData?.status?.toUpperCase() =='REGISTERED'? true: false;
      testData.noofpapers  = self.filter(v=>v.subruleid == testData?.subruleid )?.length +this.cardTestSeggeration?.completedTests?.filter(v=>v.subruleid == testData?.subruleid )?.length +this.cardTestSeggeration?.ongoingTests?.filter(v=>v.subruleid == testData?.subruleid )?.length
      this.testsByScheduleId[testData?.subruleid].push(testData);
      this.testsByScheduleId[testData?.subruleid]?.sort((a,b)=>a?.papernum - b?.papernum)
    })
    this.cardTestSeggeration?.completedTests?.sort((a, b) => Number(new Date(b?.CreatedAt)) - Number(new Date(a?.CreatedAt)))?.forEach((testData, i, self) => {
      if (!this.testsByScheduleId[testData?.subruleid]) {
        this.testsByScheduleId[testData?.subruleid] = [];
      }
      testData.enrolled = true;
      testData.noofpapers = self.filter(v => v.subruleid == testData?.subruleid)?.length + this.cardTestSeggeration?.upcomingTests?.filter(v => v.subruleid == testData?.subruleid)?.length +this.cardTestSeggeration?.ongoingTests?.filter(v=>v.subruleid == testData?.subruleid )?.length;
      // testData.totaltimespend = this.timeConvert(testData?.timespent||0)
      this.testsByScheduleId[testData?.subruleid].push(testData);
      // this.testsByScheduleId[testData?.scheduleid]?.reverse()
      this.testsByScheduleId[testData?.subruleid]?.sort((a,b)=>a?.papernum - b?.papernum)

    })    
    // test_  = this.cardTestSeggeration?.upcomingTests;
    this.scheduleIds = [...new Set(this.cardTestSeggeration?.completedTests?.map(v=>v?.subruleid)),...new Set(this.cardTestSeggeration?.upcomingTests?.map(v=>v?.subruleid)),...new Set(this.cardTestSeggeration?.ongoingTests?.map(v=>v?.subruleid))]   
    this.JeeadvacedScheduleIds =   [...new Set(this.cardTestSeggeration?.upcomingTests?.map(v=>v.subruleid) )]?.map((subruleid:any)=>{           
      let examSubmittebysuser =  this.testsByScheduleId?.[subruleid]?.filter(totaltest => totaltest?.isExamSubmittedByUser)
      let  findscheduleid = this.cardTestSeggeration?.upcomingTests.find(v=>v?.subruleid == subruleid)
      return{
          scheduleid:findscheduleid?.scheduleid,
          subruleid:subruleid,
          totalNumberOfJeeAdv:this.testsByScheduleId?.[subruleid],
          examAlreadySubmittedbyUser: examSubmittebysuser,
          timeExpiresForall:this.testsByScheduleId?.[subruleid]?.every(totaltest => totaltest?.isExamTimeExpired || totaltest?.isExamSubmittedByUser),
          displayStartEndDate:this.getTotalExamTimeTaken(subruleid),
          total_score_all_attemptedTest:examSubmittebysuser.reduce((a,v)=>(a+v?.totalScore),0),
          total_score_outofscore_attemptedTest:examSubmittebysuser.reduce((a,v)=>{a = a+v?.score;return a},0)
        }
        })?.filter(v=> !v.timeExpiresForall && (v.totalNumberOfJeeAdv?.length != v.examAlreadySubmittedbyUser?.length));
    this.cardTestSeggeration?.completedTests?.forEach(ct => {
     
      let checkScdeuleinupcoming = this.JeeadvacedScheduleIds.findIndex(v => v.subruleid == ct.subruleid)
      if (checkScdeuleinupcoming == -1) {
        this.completedJeeAdvTest.push(ct)
      }
    })
    this.completedJEEAdvancedScduleId = [...new Set(this.completedJeeAdvTest?.map(v => v?.subruleid))]
                      if (this.isTimeBoundTestType) {
                        /* checking user has alrady enrolled the exam or not */      
                          this.cardTestSeggeration?.ongoingTests?.forEach((enrolledExamsDetails: any) => {
                            enrolledExamsDetails.enrolled = true                
                          });
                      }
                      // this.studentExamResult = [...this.cardTestSeggeration?.completedTests];//allTestsbyStudent;
                      // console.log('this.studentExamResult: ', this.studentExamResult);
                      
                      /* for resume functionality of a test if he has already started the exam */
                      this.scheduleIds.forEach(id => {
                        const scdl: any = this.schedulesInfo[id] = {
                          totaltimespend: 0,
                          score: 0,
                          examsubmittedon: '',
                          rank: 0,
                          percentile: 0,
                          totalScore: 0,
                          schedulename: '',
                          expanded: false,
                          displayStartEndDate:this.getTotalExamTimeTaken(id)
                        };
                        const testTakenCount: any = {}
                        this.testsByScheduleId[id]?.forEach(test => {
                          scdl.schedulename = test.schedulename;
                          scdl.enrolled = test.enrolled;            
                          if(test.resume) {
                            scdl.resume = true;
                          } else if(test.testtaken) {
                            testTakenCount[id] = testTakenCount[id] ? ++testTakenCount[id]: 1;
                            scdl.testtaken = test?.noofpapers ==testTakenCount[id] ?true:false //testTakenCount[id] > 1;  
                            scdl.totaltimespend += test.timespent
                            scdl.score += test.score
                            scdl.examsubmittedon = test.examsubmittedon
                            scdl.rank = test.rank ? test.rank : 0;
                            scdl.percentile = test.percentile ? test.percentile : 0;
                            scdl.totalScore +=  test?.totalScore;
                          }
                        });
                        scdl.TotaltestAttempted = this.testsByScheduleId[id]?.filter(v=>v.testtaken)?.length
                      });
        if(this.isTimeBoundTestType) {          
          this.filterUnattempted();
          if(this.examName == 'JEEADVANCED'){
              this.saveJeeAdvAllRuleIds= this.JeeadvacedScheduleIds?.reduce((a,v)=>{​​
                a=a.concat(v?.totalNumberOfJeeAdv?.map(inv=>inv?._id))
                return a},[])
            }else{
              this.saveJeeAdvAllRuleIds = this.filterTestList?.map(inv=>inv?._id)
            }
        }else {
          this.filterUnattempted();
        }
        const timeboundTestsExist = this.updateTimeboundTests();
        if (timeboundTestsExist) {
          if (this.latestTimeboundTestInterval) {
            this.latestTimeboundTestInterval.stop();
          }
          this.latestTimeboundTestInterval = new TaskTimer(30000);
          this.latestTimeboundTestInterval.add(task => {
            this.updateTimeboundTests();
          }).start(); 
        }
          this.checkIfUserSubscribed();
          this.spinner.hide();
        // });

    // });
  }
  webevent(params) {
    if (params['examtype'] === 'MOCKTEST'|| params['examtype'] == 'New NEET Mock Test' || params['examtype'] === 'PREVIOUSYEAR')  {
      const key = params['examtype'] == 'MOCKTEST' ? 'mock': params['examtype'] === 'PREVIOUSYEAR' ?'pyp' :'new_pattern_mock';
      this.gaService.sendEvent(
        `${key}_test_dashboard`, 
        `${key}_dashboard`, 
        `${key}_test_dashboard`, 
        'landed',  
      );
    }
    this.showSyallbusButton = this.portal !='SCORE' && (this.examtype?.toUpperCase().indexOf('TIMEBOUND') > -1 || this.examtype?.toUpperCase()?.indexOf('MOCK') > -1||CUETExamtypes.indexOf(this.examtype) > -1) && ['6','7','8','9','10','11','12','13'].indexOf(String(this.detail?.grade)?.replace(/[^0-9]/ig,'')) > -1;
  }
  getTotalExamTimeTaken(scheduleid){
  let startExam = this.testsByScheduleId?.[scheduleid].slice(0,1)?.[0]
  let Endexam = this.testsByScheduleId?.[scheduleid].slice(-1)?.[0]
  let starttime =startExam?.span? moment(startExam?.span, 'YYYY-MM-DD HH:mm A').format('Do MMM YYYY  (hh:mm A '):'';
  let endtime = Endexam?.span? moment(Endexam?.span, 'YYYY-MM-DD HH:mm A').add(parseInt(Endexam?.duration), 'minutes').format('- hh:mm A)'):'';
    return  starttime+endtime;
  }
  getTheStatusOfExam(test){
    return this.testsByScheduleId[test].some(v=>v.availableForAttempt)
  }
  openFullReport(type,schedules){
    this.testListService.selectedReportPaper = type;
    if(type =='all'){
      this.viewTestReport(schedules?.[0],false)
    }
  }
  accordianExam(overalltest){
   const test = overalltest?.totalNumberOfJeeAdv?.find(v=>((v?.isExamInProgress || v?.availableForAttempt) && !v?.isExamSubmittedByUser))
   this.attemptTestNow(test, this.examtype);
  }
}
export async function  viewTestReport(test: any, forSchedule: boolean = false) {
  if(!test['testtaken'] || (test.coursetype == 'SCORE' && test.examtype != 'MOCKTEST')) return;
  this.examService.setPresentExamInfo(test);
  this.examService.setNewQuestions(null);
  this.examService.setQuestionsData(null);
  if (test?.examtype == "subjectivemocktest") {
    this.router.navigate(['/dashboard/viewsolutionspage']);
  }
  else if (forSchedule) {
    this.router.navigateByUrl('/dashboard/viewtestreport?schedule=' + test.scheduleid);
  } else {
    if (checkILTSRevampapplicable(test) && (timeBoundTypes.indexOf(test?.examtype) > -1) && environment?.reportRevamp && !(test?.examtype == 'SCOREAWAT' || test?.examtype == 'SCOREMOCKTEST')) {
      // await this.testListService.getServerTime();
      localStorage.setItem('serverTime', this.getMomentUTCtime())
      let examendDateTime = examEndtime(test);
      let serverTime = localStorage.getItem('serverTime');
      let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");
      var exam_endtime_5min = moment(examendDateTime, "YYYY-MM-DD HH:mm:ss").add(5, 'minute')
      if (moment(current_time).isAfter(exam_endtime_5min)) {
        this.router.navigate(['/dashboard/viewtestreport']);
      } else {
        this.router.navigate(['/dashboard/reportQueue']);
      }
    } else {
      this.router.navigate(['/dashboard/viewtestreport']);
    }
  }
}